"use strict";

document.addEventListener("DOMContentLoaded", function () {
  var search_button = document.getElementById('search'),
      search_container = document.getElementById('search-form-container'),
      search_submit = document.getElementById('search-submit'),
      search_button_mobile = document.getElementById('mobile-search-btn');
  search_button.onclick = toggleSearch;
  search_button_mobile.onclick = toggleSearch;

  function toggleSearch(e) {
    e.preventDefault();
    search_container.classList.toggle('hidden');
    search_button.classList.toggle('active');
    search_button_mobile.classList.toggle('active');
    search_button.lastChild.classList.toggle('icon-search');
    search_button.lastChild.classList.toggle('icon-cross');
    anime({
      targets: '#search-form-container',
      scaleY: [0, 1],
      easing: 'linear',
      duration: 200
    });
  }
});